/**
 * Migrate legacy bullet-list items (flat strings) to enriched shape ({ text, suffix }).
 * Passes through already-migrated items unchanged.
 */
export function migrateItems(raw) {
  if (!Array.isArray(raw)) return []
  return raw.map((item) =>
    typeof item === 'string'
      ? { text: item, suffix: null }
      : item,
  )
}
